import {
  logout,
  loadMemberProjectInfo,
  getCurrentOrgInfo,
  getOrgProductRights,
  notifyTimeZoneChanged,
  getUserAssembleInfo,
  userHabitRecord,
  userHabitQuery,
  loadProductModuleSupport
} from '@/api/user';
import { checkStorage } from 'common-module/src/api/user';
/* eslint-disable */
                 
import { getSubscriptionOrder } from 'common-module/src/api/price';
         
/* eslint-disable */
import { getToken, setToken, removeToken, getUserName, setUserName, removeUserName } from 'common-module/src/util/auth';
import { parseQueryString } from '@zk/framework-vue';
import { shareInfo } from '@/api/share';
import loginAfter from '@/store/loginAfter';
import dayjs from 'dayjs';
import { loadAllLanguage } from 'common-module/src/lang';
import { getCache, setCache } from '@zk/framework-vue';
import { deleteIndexedDB, ifReloadI18n } from 'common-module/src/util';
import versions from '@/utils/versions';
import config from 'common-module/src/config';
import { isEmpty } from 'lodash';
import {
  updateCurrentProjectRoleWithVuex, updateRightsVersionWithVuex,
  updateUserPermissionWithVuex,
  updateUserRoleWithVuex
} from '../../stores/updateWithVuexData';
import {
  checkPermission, isProjectInnerCollaborator, isProjectInnerCollaboratorButNotAdmin,
} from '../../stores/useResourcePermissionStore';
import RemoteGuide from 'common-module/src/util/guide';

const state = {
  account: {},
  org: {},
  token: getToken(),
  name: getUserName(),
  avatar: '',
  introduction: '',
  roles: [],
  /**
   * 当前项目角色，每次切换项目时会重新加载
   */
  currentProjectRoles: [],
  productRights: {},
  shareInfo: {},
  shareLanguage: '',
  messageBannerList: [],
  asideCollapse: getCache('left-nav-collapse', 'none') || false,
  storageRight: {}, // 产品存储容量
  // 侧边栏项目切换前的回调
  asideBeforeProjectChangeCb: [],
  // 接下来打开的事项详情是否为预览模式
  enterPreviewMode: false,
  moduleSupport: {},
  /* eslint-disable */
                   
  overseasSubscription: null
           
  /* eslint-disable */
};

const mutations = {
  SET_ENTER_PREVIEW_MODE(state, value) {
    state.enterPreviewMode = value;
  },
  SET_ASIDE_COLLAPSE(state, value) {
    setCache('left-nav-collapse', value, { version: 'none' });
    state.asideCollapse = value;
  },

  SET_TOKEN: (state, token) => {
    state.token = token;
    setToken(token);
  },
  SET_SHARE_TOKEN: (state, { token, shareCode }) => {
    state.token = token;
    sessionStorage.setItem('share-code', shareCode);
    sessionStorage.setItem(`token-share-${shareCode}`, token);
  },
  SET_SHARE_INFO: (state, shareInfo) => {
    state.shareInfo = shareInfo;
  },
  SET_ACCOUNT: (state, account) => {
    state.account = account;
    updateUserPermissionWithVuex(account);
  },
  SET_ORG: (state, org) => {
    state.org = org;
  },
  SET_PRODUCT_RIGHTS: (state, res) => {
    // 如果没有产品权益信息(state.productRights为空)，直接赋值
    if (isEmpty(state.productRights)) {
      state.productRights = res;
      updateRightsVersionWithVuex(res);
      return;
    }
    // 判断新数据中是否包含人员权益信息
    const hasPersonRight = res?.newRightList?.some(item => item.accountRight);
    // 如果包含人员权益，则直接赋值
    if (hasPersonRight) {
      state.productRights = res;
      updateRightsVersionWithVuex(res);
      return;
    }
    // 如果新数据中不包含人员权益，则将老数据中的人员权益合并
    const personRights = state.productRights?.newRightList?.filter(item => item.accountRight);
    if (res.newRightList && personRights?.length) {
      res.newRightList.push(...personRights);
    }
    state.productRights = res;
    updateRightsVersionWithVuex(res);
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction;
  },
  SET_NAME: (state, name) => {
    state.name = name;
    setUserName(name);
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
    updateUserRoleWithVuex(roles);
  },
  SET_CURRENT_PROJECT_ROLES: (state, roles) => {
    state.currentProjectRoles = roles;
    updateCurrentProjectRoleWithVuex(roles);
  },
  SET_SHARE_LANGUAGE: (state, language) => {
    state.shareLanguage = language;
  },
  SET_SUBSCRIPTION: (state, info) => {
    state.overseasSubscription = info;
  },
  SET_PRODUCT_STORAGE_RIGHT: (state, data) => {
    state.storageRight = data;
  },
  SET_ASIDE_BEFORE_PROJECT_CHANGE_CB: (state, cb) => {
    state.asideBeforeProjectChangeCb.push(cb);
  },
  REMOVE_ASIDE_BEFORE_PROJECT_CHANGE_CB: (state, cb) => {
    state.asideBeforeProjectChangeCb = state.asideBeforeProjectChangeCb.filter(i => i !== cb);
  },
  SET_MODULE_SUPPORT: (state, data) => {
    state.moduleSupport = data;
  }
};

const tryNotifyTimezoneChange = (timeZone) => {
  try {
    if (timeZone !== Intl.DateTimeFormat().resolvedOptions().timeZone) {
      notifyTimeZoneChanged(Intl.DateTimeFormat().resolvedOptions().timeZone);
    }
    // eslint-disable-next-line no-empty
  } catch (e) { }
};

const actions = {
  async saveDashboard({ state }, value) {
    await userHabitRecord({
      linkIdList: [value],
      linkType: 'userHomePageSelected',
      projectId: 0,
      userId: state.account.userId
    });
  },
  async getDashboard({ state }) {
    const res = await userHabitQuery({
      linkType: 'userHomePageSelected',
      projectId: 0,
      userId: state.account.userId
    });
    console.log('--getDashboard--', state, res, res.result?.['linkIdList']?.[0]);

    return res.result?.['linkIdList']?.[0];
  },
  async shareAnonymousLogin({ commit, state }, { token, shareCode }) {
    commit('SET_SHARE_TOKEN', { token, shareCode });
    commit('SET_ROLES', [{ roleCode: 'anonymous', enabled: 1 }]);
    commit('SET_ACCOUNT', { userId: shareCode });
    const locale = state.shareLanguage.slice(0, 2);
    await loadAllLanguage(shareCode, locale, token);
  },
  clearShareAnonymous({ commit }) {
    const query = parseQueryString(window.location.href);
    const { shareCode } = query;
    if (shareCode) {
      commit('SET_SHARE_TOKEN', { shareCode, token: '' });
    }
  },
  async loadShareInfo({ commit, state }, { shareCode, force = false }) {
    if (!force && state.shareInfo.projectId) return;
    const info = await shareInfo(shareCode);
    commit('app/SET_CURRENTPROJECT', info.projectId, { root: true });
    commit('app/SET_CURRENTPROJECTKEY', info.pkey, { root: true });
    commit('SET_SHARE_LANGUAGE', info.language);
    commit('SET_SHARE_INFO', info);
  },
  loadUserInfo({ dispatch }, token) {
    return dispatch('refresh', { token, force: true });
  },
  async justLoadUserInfo({ commit, state, getters, dispatch }, { token } = {}) {
      token = token || getToken()
      const info = await getUserAssembleInfo(token);
      const { userInfo } = info;
      commit('SET_TOKEN', token);
      commit('SET_ACCOUNT', userInfo);
      commit('SET_ROLES', userInfo.roleVOList?.filter(r => r.roleCode.startsWith('organization') || ['member', 'innerCollaborator'].includes(r.roleCode)) || []);
      commit('SET_NAME', userInfo.userName);
      tryNotifyTimezoneChange(userInfo.timeZone);
      await dispatch('features/init', userInfo.features, { root: true });
      return info;
  },

  async refresh({ commit, getters, dispatch, state }, { force = false, token } = {}) {
    if (force || !getters.userId) {
      try {
        token = token || getToken()
        const { orgInfo } = await dispatch('justLoadUserInfo', { token });
        await dispatch('changeOrgInfo', { info: orgInfo, token });
        dispatch('loadProductModuleSupport');
        try {
          await RemoteGuide.identify(getters.userId, {
            name: state.account?.orgUserName,
            email: state.account?.orgEmail,
            signed_up_at: dayjs(state.account?.joinTime).toISOString(),
          });
          await RemoteGuide.group(getters.orgId, { 
            name: getters.orgName, 
            key: getters.orgKey, 
            language: state.org?.language, 
            version: getters.rightVersion 
          }, { 
            roles: state.roles?.map(role => role.roleCode) ?? []
          });
        } catch {}
      } catch (e) {
        if (e.res?.code === '0418') {
          commit('SET_ACCOUNT', { userId: 'temporary0418' });
          commit('SET_ORG', { id: 'temporary0418' });
        } else {
          throw e;
        }
      }
    }
    return state.account;
  },

  async changeOrgInfo({ commit, getters }, { info, token }) {
    commit('SET_ORG', info);
    const locale = info?.language.slice(0, 2);
    await ifReloadI18n(locale);
    await loadAllLanguage(getters.orgId, locale, token, true);
    dayjs.locale(locale);
    dayjs.orgTimeZone = info.timeZone;
  },

  /**
   * 刷新组织信息
   * @param commit
   * @param getters
   * @param force
   * @param token
   * @returns {Promise<boolean>}
   */
  async refreshOrg({ getters, dispatch }, { force = false, token } = {}) {
    if (!force) {
      if (getters.orgKey) {
        return true;
      }
    }
    const info = await getCurrentOrgInfo(token);
    await dispatch('changeOrgInfo', { info, token });
    return true;
  },
  initData({ dispatch }, token) {
    return Promise.all([
      dispatch('refreshProductRights', { token }),
      dispatch('orgSubscription', { token })
    ]);
  },
  async validateToken(ctx, token) {
    const { getters, dispatch, state, commit } = ctx;
    try {
      // 每次route变更时触发
      if (getters.userId) {
        return true;
      }
      await dispatch('refresh', { token });
      commit('SET_TOKEN', token);
      if(state.org?.id) {
        await dispatch('initData', token);
      }
      try {
        await loginAfter(this._vm, state, ctx, this, token);
        versions.init();
      } catch (e) {
        window.console.warn('init after error', e);
      }
      return true;
    } catch (e) {
      await dispatch('resetToken');
      window.console.warn('验证token失败', e);
      return false;
    }
  },
  // user logout
  async logout({ commit, state }) {
    try {
      await logout(state.token);
    } finally {
      commit('SET_TOKEN', '');
      commit('SET_ROLES', []);
      removeToken();
      removeUserName();
      localStorage.removeItem('account');
      localStorage.removeItem('language');
      this._vm.$track?.logout();
      RemoteGuide.reset();
      try {
        await deleteIndexedDB(config.VUE_APP_DB_NAME, state.account.userId, state.account.orgId);
      } catch (e) {
        console.log('删除indexedDB失败', e);
      }
    }
  },

  clear({ dispatch }) {
    dispatch('resetToken');
  },

  // remove token
  resetToken({ commit, dispatch }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '');
      commit('SET_ROLES', []);
      removeToken();
      removeUserName();
      localStorage.removeItem('account');
      commit('SET_ACCOUNT', {});
      commit('SET_ORG', {});
      dispatch('app/clearProjects', null, { root: true });
      dispatch('clearShareAnonymous');
      this._vm.$track?.logout();
      resolve();
    });
  },
  async loadProjectRoles({ commit }, { projectId }) {
    const result = await loadMemberProjectInfo(projectId);
    commit('SET_CURRENT_PROJECT_ROLES', result || []);
  },
  async loadProductModuleSupport({ commit}) {
    const result = await loadProductModuleSupport();
    commit('SET_MODULE_SUPPORT', result || {});
  },

  /**
   * 刷新用户产品授权信息
   * @param dispatch
   * @param state
   * @param force
   * @param productLineId
   * @param token
   * @returns {Promise<boolean>}
   */
  async refreshProductRights({ dispatch, getters, state }, { force = false, productLineId = 1, token } = {}) {
    if (!force) {
      if (state.productRights?.id) {
        return true;
      }
    }
    await dispatch('orgProductRights', { productLineId, token });
    RemoteGuide.setGroupProperties({ version: getters.rightVersion });
    return true;
  },
  /**
     * 获取用户产品权益信息
     * @param commit
     * @param productLineId
     * @param token
     * @returns {Promise<void>}
     */
  async orgProductRights({ commit }, { productLineId = 1, token = state.token } = {}) {
    const result = await getOrgProductRights({ productLineId }, token);
    commit('SET_PRODUCT_RIGHTS', result);
  },
  /**
   * 获取用户订阅信息（海外）
   */
  async orgSubscription({ commit }) {

    /* eslint-disable */
                     
    const result = await getSubscriptionOrder();
    commit('SET_SUBSCRIPTION', result);
             
    /* eslint-disable */
  },
  /**
   * 检查存储容量是否充足
   */
  async checkStorageRight({ commit }) {
    const res = await checkStorage({ productLineId: 1, rightType: 'storageNum' });
    if (res?.remainingNum > 0) {
      return true;
    }
    let storage = {};
    if (res === '1610') {
      storage = {
        isStorageTip: false,
        isExpirationTip: true
      }
    } else {
      storage = {
        isStorageTip: true,
        isExpirationTip: true,
        storageData: res
      }
    }
    commit('SET_PRODUCT_STORAGE_RIGHT', storage);
    return false;
  },

  /**
   * 权限变更的时候调用
   * 内部其实可以精简（如果使用hook的方式）
   * @returns {Promise<void>}
   */
  async refreshPermission({ dispatch }, payload) {
    const { refreshOrg = false, refreshProject = false } = payload || {};
    const calls = [];
    if (refreshOrg) {
      calls.push(dispatch('justLoadUserInfo'))
    }
    if (refreshProject) {
      calls.push(dispatch('app/loadProjects', true, { root: true }));
    }
    await Promise.all(calls);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters: {
    showAsideCollapse: state => state.asideCollapse,
    userId: state => state.account?.userId,
    userName: state => state.account?.orgUserName || getUserName(),
    avatar: state => state.account?.head,
    isEnabled: state => state.account?.enabled !== false,
    email: state => state.account?.orgEmail,
    phone: state => {
      const { phoneNumber, countryCode } = state.account || {};
      if (phoneNumber && countryCode) {
        const phone = phoneNumber.replace(/^(.{3})(.*)(.{4})$/, '$1 $2 $3');
        return `+${countryCode} ${phone}`;
      }
      return null;
    },
    orgId: state => state.account?.orgId,
    orgName: state => state.org?.orgName || '',
    orgKey: state => state.org?.orgKey,
    orgAvatar: state => state.org?.avatar,
    orgUUID: state => state.org?.uuid,
    orgMiniAvatar: state => state.org?.miniLogo,
    currentProductLine: state => state.account?.productLineVOList?.[0]?.id,
    permissionAsg: state => state.account?.orgRolePermissionVOList?.map(i => i.code) || [],
    roleCodes: state => [...(state.currentProjectRoles || []), ...(state.roles || [])].filter(r => r.enabled === 1)?.map(i => i.roleCode) || [],
    productLineId: state => state?.account?.productLineVOList?.[0]?.id,
    isAnonymous: (state, getters) => getters.roleCodes.includes('anonymous'),
    isProjectInnerCollaborator: state => isProjectInnerCollaborator(),
    isProjectInnerCollaboratorButNotAdmin: () => isProjectInnerCollaboratorButNotAdmin(),
    isProjectInnerCollaboratorButNotAdminWithProject: () => (projectId) => isProjectInnerCollaboratorButNotAdmin(projectId),
    checkRole: (state, getters) => (roles, and = false, roleCodes) => {
      if (Array.isArray(and)) {
        roleCodes = and;
        and = false;
      }
      let _roleCodes = getters.roleCodes;
      if (Array.isArray(roleCodes)) {
        _roleCodes = roleCodes;
      }
      const fn = and ? Array.prototype.every : Array.prototype.some;
      return Reflect.apply(fn, roles, [need => Reflect.apply(fn, _roleCodes, [role => need === '*' || role === need])]);
    },
    checkModuleSupport: (state, getters) => (moduleName) => {
      return !!state.moduleSupport[moduleName];
    },
    checkAccessPermission: (state, getters, rootState, rootGetters) => (options) => {
      return checkPermission(options, {
        getters: rootGetters
      })
    },
    checkAccessPermissionWithProject: (state, getters, rootState, rootGetters) => (options) => {
      const { id, meta } = options || {}
      return checkPermission(meta, { projectId: id, getters: rootGetters })
    },
    userProductRights: state => state.productRights,
    messageBannerNoticeList: state => state.account.productMessageBannerVOList || [],
    getRightData: state => type => state.productRights?.newRightList?.find(item => item.rightType === type) || {},
    getMemberNum: (state, getters) => getters.getRightData('memberNum') || {},
    getAICredit: () => state.productRights?.newRightList?.filter(i => i.rightType === 'aiCredit') || [],
    /**
     * 是否已登录，含匿名账号
     * @param state
     * @param getters
     * @returns {boolean}
     */
    isLogin: (state, getters) => !!getters.userId && !!state.token,
    rightVersion: (state) => {
      const type = state.productRights?.productSchemeVO?.schemeType;
      switch (type) {
        case 0: return 'free'
        case 1: return 'trial'
        case 2: return 'standard'
        case 3: return 'professional'
        case 5: return 'private'
        default: return 'unknown'
      }
    }
  }
};
